<template>
    <textarea v-model="val"  class="form-control "></textarea>
</template>
<script>
export default {
    props: ['antecedente','value'],
    data () {
        return{
            val:this.value,
        }
    },
    watch:{
        val:function(){
            this.$emit('input',this.val);
        },
        
    }
}
</script>


